

















	import {Vue, Component} from 'vue-property-decorator';
	import PageTitle from '@/components/common/PageTitle.vue';
	import PartnerEditForm from '@/components/partner/PartnerEditForm.vue';
	
	@Component({
		components: {
			PartnerEditForm,
			PageTitle
		}
	})
	export default class PartnerEditPage extends Vue {
		// 파트너 조회 및 수정 초기 정보
		private getPartnerRequestByNo = {
			// 파트너 조회
			pathParams: {
				partnerNo: this.$route.params.partnerNo
			}
		}
		private postPartnerRequestInitialData = {
			officeAddress: {
				zipCode: '',
				streetAddress1: '',
				streetAddress2: '',
				jibunAddress1: '',
				jibunAddress2: '',
				city: '',
				stateOrRegion: '',
			},
			partnerName: '',
			companyName: '',
			sellerTaxationType: undefined,
			faxNo: '',
			representative: {
				representName: '',
				representEmail: '',
				representPhoneNo: '',
			},
			business: {
				businessCondition: '',
				businessRegistrationNo: '',
				businessType: '',
				onlineMarketingBusinessDeclarationNo: '',
			},
			settlement: {
				settlementManagerEmail: '',
				settlementManagerName: '',
				settlementManagerPhoneNo: '',
			},
			bank: {
				tradeBank: '',
				tradeBankAccount: '',
				tradeBankDepositorName: '',
				tradeBankName: '',
			},
			masterAdmin: {
				masterJobPositionName: '',
				masterDepartmentName: '',
				masterPhoneNo: '',
				masterMobileNo: '',
				masterJobName: '',
				externalAccess: false,
				permittedIpAddresses: [],
			},
			permittedIpAddress: '',
			privacyManager: {
				privacyManagerName: '',
				privacyManagerPhoneNo: '',
			},
			manager: {
				managerDepartment: '',
				managerEmail: '',
				managerJobDuty: '',
				managerJobPosition: '',
				managerName: '',
				managerPhoneNo: '',
			},
			sampleUrl: '',
			internationalCode: {
				ibanCode: '',
				abaRoutingNo: '',
				swiftCode: '',
				bsbCode: ''
			},
			csManager: {
        csManagerName: '',
        csManagerPhoneNo: '',
        csManagerEmail: '',
        csManagerOperationInfo: '',
      }
		}
		private postPartnerRequestByNo = {
			...this.getPartnerRequestByNo,
			data: {
				...this.postPartnerRequestInitialData
			}
		}
		
		// 계약서 조회 및 수정 초기 정보
		private getContractsRequestByNo = {
			params: {
				partnerNo: Number(this.$route.params.partnerNo)
			}
		}
		private postContractsRequestInitialData = {
			contracts: [
				{
					commissionRate: 0,
					contractNo: -1,
					promotionAgreed: false,
					useDefaultCommissionRate: false
				}
			]
		}
		private postContractsRequestByNo = {
			data: {
				partnerNo: this.getContractsRequestByNo.params.partnerNo,
				contracts: this.postContractsRequestInitialData.contracts
			}
		}
		
		// 입점 계약서 조회 및 수정 초기 정보
		private getEntryContractsRequestByNo = {
			pathParams: {
				contractNo: '',
				// agreed?: false
			}
		}
		private postEntryContractsRequestInitialData = {
			contractContents: '',
			changeReason: ''
		}
		private postEntryContractsRequestByNo = {
			pathParams: {
				contractNo: this.getEntryContractsRequestByNo.pathParams.contractNo
			},
			data: {
				...this.postEntryContractsRequestInitialData
			}
		}
		
		// 라디오 버튼 생성 초기 정보
		private radioInitialOptions = {
			externalAccess: {
				name: 'externalAccess',
				data: [
					{
						id: 'externalAccess1',
						value: 'true',
						dispaly: 'PARTNER_EDIT_EXTERNAL_ACCESS_Y'
					},
					{
						id: 'externalAccess2',
						value: 'false',
						dispaly: 'PARTNER_EDIT_EXTERNAL_ACCESS_N'
					}
				]
			},
		}
	}
